<template>
    <div>
        <div class=" max-w-5xl mx-auto">
            <osv-reset-password />
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
</style>